var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix), 'sw-flexbox', 'sw-flexbox--center-justify']},[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":require("../../../libs/unified-ui-framework/src/assets/images/logo-dark.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }